import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateEmailConfigurationSettings } from './updateEmailConfigurationSettings';
import { EmailConfigurationPayload } from './types';
import { COMPANY_API_SETTINGS_MOCKED } from '@/env';
import { QUERY_KEY_SETTINGS_EMAIL } from '@/lib/api/constants';

export function useMutationEmailConfigurationSettings(companyId: string) {
    const queryClient = useQueryClient();
    
    return useMutation({
        mutationFn: async (payload: EmailConfigurationPayload) => {
            if (COMPANY_API_SETTINGS_MOCKED) {
                return true
            }
            const { data } = await updateEmailConfigurationSettings({ companyId, payload })
            return data;
        },

        onError: (error) => {
            // @TODO handle error properly
            // show notification to user
            // @TODO display notification
            console.error('Error useMutationEmailConfigurationSettings:', error);
        },

        onSuccess: (saved) => {
            queryClient.invalidateQueries({ queryKey: [QUERY_KEY_SETTINGS_EMAIL, companyId] });
        },
    });
}
